import React from 'react';
import { colors } from '../../../utils/utils';

function LoudnessQuiet(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    const iconWidth = props.size ?? 32;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={iconWidth} height={(iconWidth * 29) / 32} viewBox="0 0 32 29">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path
                    stroke={colors.blue.madison}
                    strokeWidth="1.5"
                    d="M6.6 9.438H1v10.124h5.6L15.4 28H19a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-3.6L6.6 9.438z"
                />
                <path
                    stroke={colors.yellow.golden_tanoi}
                    strokeWidth="1.89"
                    d="M27.75 19.343l1.452-1.51a4.81 4.81 0 0 0 0-6.668l-1.452-1.51"
                />
            </g>
        </svg>
    );
}

export default LoudnessQuiet;
